module.exports = __webpack_public_path__ + "img/nington-qrcode-ios.ecbff929.png";